<template>
  <FileInput
    :label="inputData.label ? getLocaleText(inputData.label) : null"
    :attachments="attachments"
    :help-text="inputData.help ? getLocaleText(inputData.help) : null"
    :input-class="`ul-attachment_${inputData.id}`"
    :identifier="inputData.id"
    :has-padding="hasPadding"
    @addAttachment="attachment => addAttachment(attachment)"
    @deleteAttachment="attachment => deleteAttachment(attachment)"
  />
</template>

<script>
import formGtm from '@/mixins/formGtm';
export default {
  name: 'UlAttachmentProfile',
  mixins: [formGtm],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    },
    hasPadding: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    responses() {
      return this.$store.getters[`dynamicForms/responses`];
    },
    attachments() {
      return (
        this.$store.getters['dynamicForms/attachments'][this.formName][this.inputData.id] || []
      );
    },
    isInvalid: {
      get() {
        return this.$store.state.forms.attachments.isInvalid;
      },
      set(value) {
        this.$store.commit('forms/attachments/setIsInvalid', value);
      }
    }
  },
  created() {
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => {
      const validationValue = this.inputData.required
        ? !!(
            this.responses[this.formName][this.inputData.id] &&
            this.responses[this.formName][this.inputData.id].length
          )
        : true;
      this.$store.commit(`dynamicForms/updateValidation`, {
        id: this.inputData.id,
        value: validationValue,
        formName: this.formName
      });
      this.$nextTick(() => {
        this.isInvalid = !validationValue;
      });
    });
  },
  beforeDestroy() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    addAttachment(data) {
      this.$store
        .dispatch('dynamicForms/updateAttachments', {
          id: this.inputData.id,
          value: this.attachments.length ? [...this.attachments, data] : [data],
          formName: this.formName
        })
        .then(() => {
          this.isInvalid = false;
        });
    },
    deleteAttachment(attachment) {
      this.$store.dispatch('dynamicForms/updateAttachments', {
        id: this.inputData.id,
        value: this.attachments.filter(att => {
          if (attachment.id) {
            return att.id !== attachment.id;
          }

          return att.uuid !== attachment.uuid;
        }),
        formName: this.formName
      });
    }
  }
};
</script>
